import { Api } from "../config/request";

export default {
  getAppReleasesList(payload) {
    return Api.post(`/driver-app-releases`, payload);
  },
  getActiveAppRelease(id) {
    return Api.get(`/driver-app-release/${id}`);
  },
  createAppRelease(payload) {
    return Api.post(`/driver-app-release`, payload);
  },
  updateAppRelease(payload) {
    return Api.put(`/driver-app-release`, payload);
  },
  launchAppRelease(id, payload) {
    return Api.post(`/driver-app-releases/${id}/launch`, payload);
  },
  bulkUploadDriverIds(payload) {
    return Api.post(`/driver-app-releases/bulk/upload-drivers`, payload);
  },
  downloadAppApks(id) {
    return Api.get(`/driver-app-releases/${id}/apk`);
  },
  uploadAppApks(payload) {
    return Api.post("/driver-app-releases/bulk/upload-apks", payload);
  },
};
